<router-outlet></router-outlet>

<!-- Modals -->
@for (modal of ms.modals(); track $index) {
  <ui-modal [data]="modal" [ngClass]="modal.class" [style.z-index]="100 + $index" [style.view-transition-name]="'modal' + $index"></ui-modal>
}

<!-- Alerts (toasts) -->
<ui-alerts></ui-alerts>
